//@flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';
import type { VehicleModelIdModelType } from './Plan';
import { VehicleModelId } from './Plan';
import type { CrossDocksTypeEnum } from 'common/models/flow/CrossDockInfo';

export const EchelonTypes = Object.freeze({
    Primary: 1,
    Secondary: 2
});

export type EchelonTypesType = $Values<typeof EchelonTypes>;
export type CrossDockVehicleConfigModelType = {
    crossDockType: CrossDocksTypeEnum,
    leg: EchelonTypesType,
    secondaryVehicleModelId: ?VehicleModelIdModelType,
    secondaryVehicleCount: ?number,
    volumeUtilization: ?number
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class CrossDockVehicleConfig extends ImmutableModel {
    static fromJS(
        json: CrossDockVehicleConfigModelType
    ): CrossDockVehicleConfig {
        const state: Object = Object.assign({}, json);
        state.secondaryVehicleModelId = state.secondaryVehicleModelId
            ? VehicleModelId.fromJS(state.secondaryVehicleModelId)
            : state.secondaryVehicleModelId;
        return new this(Immutable.Map(state));
    }

    toJS(): CrossDockVehicleConfigModelType {
        return {
            crossDockType: this.crossDockType,
            leg: this.leg,
            secondaryVehicleModelId: this.secondaryVehicleModelId
                ? this.secondaryVehicleModelId.toJS()
                : this.secondaryVehicleModelId,
            secondaryVehicleCount: this.secondaryVehicleCount,
            volumeUtilization: this.volumeUtilization
        };
    }

    get crossDockType(): CrossDocksTypeEnum {
        return this._state.get('crossDockType');
    }

    setCrossDockType(crossDockType: CrossDocksTypeEnum): this {
        return this.clone(this._state.set('crossDockType', crossDockType));
    }

    get leg(): EchelonTypesType {
        return this._state.get('leg');
    }

    setLeg(leg: EchelonTypesType): this {
        return this.clone(this._state.set('leg', leg));
    }

    get secondaryVehicleModelId(): ?VehicleModelId {
        return this._state.get('secondaryVehicleModelId');
    }

    setSecondaryVehicleModelId(secondaryVehicleModelId: ?VehicleModelId): this {
        return this.clone(
            this._state.set('secondaryVehicleModelId', secondaryVehicleModelId)
        );
    }

    get secondaryVehicleCount(): ?number {
        return this._state.get('secondaryVehicleCount');
    }

    setSecondaryVehicleCount(secondaryVehicleCount: ?number): this {
        return this.clone(
            this._state.set('secondaryVehicleCount', secondaryVehicleCount)
        );
    }

    get volumeUtilization(): ?number {
        return this._state.get('volumeUtilization');
    }

    setVolumeUtilization(volumeUtilization: ?number): this {
        return this.clone(
            this._state.set('volumeUtilization', volumeUtilization)
        );
    }
}
